import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearNoteAction, getNoteByIdAction } from '../../../redux/actions/notesActions';
import CommonLoader from '../../shared/loaders/CommonLoader';
import Modal from '../../shared/modal/Modal';
import TiptapEditor from '../TiptapEditor';

const PreviewNoteModal = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const selectedNote = useSelector((state) => state.notes?.selectedNote);
  const note = useSelector((state) => state.notes?.note);
  const noteLoading = useSelector((state) => state.notes?.noteLoading);

  useEffect(() => {
    if (selectedNote?.id) {
      dispatch(getNoteByIdAction(selectedNote.id));
    }
    return () => dispatch(clearNoteAction());
  }, [dispatch, selectedNote?.id]);

  return (
    <Modal
      title={selectedNote?.title || 'Нотатка'}
      onClose={onModalClose}
      body={
        noteLoading ? (
          <CommonLoader />
        ) : (
          note && <TiptapEditor content={note.content} onUpdate={() => {}} editable={false} />
        )
      }
    />
  );
};

export default PreviewNoteModal;
